module.exports = __webpack_public_path__ + "img/livemap_editbeacons_childbeaconsexample4.1f7e3c1e.png";